<script setup>
import { onMounted, ref } from 'vue';

const model = defineModel();

defineProps({
    hasError: Boolean,
});

const input = ref(null);

onMounted(() => {
    if (input.value.hasAttribute('autofocus')) {
        input.value.focus();
    }
});

defineExpose({ focus: () => input.value.focus() });
</script>

<template>
    <input
        ref="input"
        v-model="model"
        class="focus:ring-1 placeholder-gray-500 rounded-md"
        :class="hasError ? 'text-red-900 border-red-600 focus:border-red-600 focus:ring-red-600' : 'border-gray-300 focus:border-deep-teal-600 focus:ring-deep-teal-600'"
    >
</template>
